import * as EmailValidator from 'email-validator'

export const isValidEmail = (email: string) => {
  return EmailValidator.validate(email)
}
